module.exports = __webpack_public_path__ + "static/media/showroom_reserve_project.7bd6989a.svg";